module.exports = __webpack_public_path__ + "static/media/gmn-paint-dept.7af66984.png";